import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AlertController, ModalController } from "@ionic/angular";
import { QuestionGroup, QuestionGroupCategory, QuestionTypeConfig } from "src/app/shared/interfaces/process-config.interface";
import { SelectItem } from "src/app/shared/classes/SelectItem";
import { TranslationService } from "src/app/shared/services/translation.service";
import { QuestionGroupAttributesComponent } from "./question-group-attributes/question-group-attributes.component";
import { ProcessTypeEnum } from "src/app/shared/interfaces/process.interface";
import { Version } from "src/app/processes/_interfaces/version.interface";
import { ManageQuestionGroupComponent } from "../../manage-question-group/manage-question-group.component";

@Component({
    selector: "app-question-group",
    templateUrl: "./question-group.component.html",
    styleUrls: ["../../manage-version.page.scss"],
})
export class QuestionGroupComponent implements OnInit {
    @Input() isManagerGroup: boolean;
    @Input() version: Version;
    @Input() group: QuestionGroup;
    @Input() questionTypeConfigs: QuestionTypeConfig[] = [];
    @Input() readonly language: string;
    @Input() groupsSelectItems: SelectItem[];
    @Output() changeGroupFromQuestion: EventEmitter<{ questionId: number; newGroupId?: number; manager: boolean }> = new EventEmitter();
    @Output() moveUpGroup: EventEmitter<string> = new EventEmitter();
    @Output() moveDownGroup: EventEmitter<string> = new EventEmitter();
    @Output() addQuestion: EventEmitter<string> = new EventEmitter();
    @Output() removeQuestionGroup: EventEmitter<string> = new EventEmitter();

    public hasAttributesConfig: boolean = false;

    constructor(
        private _modalController: ModalController,
        private _alertController: AlertController,
        private _translationService: TranslationService,
    ) {}

    ngOnInit() {
        this.hasAttributesConfig =
            this.version.type === ProcessTypeEnum.SelfEvaluation ||
            this.version.type === ProcessTypeEnum.ManagerEvaluation ||
            this.version.type === ProcessTypeEnum.TwoPlusTwoCoachingValidation ||
            this.version.type === ProcessTypeEnum.ThreeSixtyEvaluation ||
            this.version.type === ProcessTypeEnum.FreeEvaluationEndYear ||
            this.version.type === ProcessTypeEnum.FreeEvaluationMidYear ||
            this.version.type === ProcessTypeEnum.FinalFeedback;
    }

    public async manageGroup() {
        const modal = await this._modalController.create({
            component: ManageQuestionGroupComponent,
            cssClass: "view-goals-modal-style ruling",
            componentProps: {
                language: this.language,
                typeConfig: null,
                group: this.group,
            },
        });

        return await modal.present();
    }

    public deleteQuestion(questionId: string): void {
        const index = this.group.questions.findIndex((q) => q.guid === questionId);
        this.group.questions.splice(index, 1);

        this.group.questions.forEach((question, qIndex) => (question.order = qIndex + 1));
    }

    public reorderQuestions(questionId: string): void {
        const index = this.group.questions.findIndex((q) => q.guid === questionId);
        const currentQuestion = this.group.questions[index];

        this.group.questions.splice(index, 1);

        this.group.questions.splice(currentQuestion.order - 1, 0, currentQuestion);

        this.group.questions.forEach((question, qIndex) => (question.order = qIndex + 1));
    }

    public changeGroup(config: any) {
        this.changeGroupFromQuestion.emit({ questionId: config.questionId, newGroupId: config.newGroupId, manager: this.group.category === QuestionGroupCategory.Manager });
    }

    public moveUp() {
        this.moveUpGroup.emit(this.group.guid);
    }

    public moveDown() {
        this.moveDownGroup.emit(this.group.guid);
    }

    public addGroupQuestion() {
        this.addQuestion.emit(this.group.guid);
    }

    public async removeGroup() {
        const alert = await this._alertController.create({
            message: this._translationService.getTranslation("manageQuestionGroup.confirmDelete"),
            buttons: [
                {
                    text: this._translationService.getTranslation("generic.no"),
                    role: "cancel",
                    cssClass: "danger",
                },
                {
                    text: this._translationService.getTranslation("generic.yes"),
                    handler: () => {
                        this.removeQuestionGroup.emit(this.group.guid);
                    },
                },
            ],
        });

        await alert.present();
    }

    public async manageAttributes() {
        const modal = await this._modalController.create({
            component: QuestionGroupAttributesComponent,
            // cssClass: '',
            componentProps: {
                language: this.language,
                typeConfig: null,
                group: this.group,
            },
        });

        return await modal.present();
    }

    public updateQuestionTypeConfig(questionType: QuestionTypeConfig) {
        this.group.questions.forEach((q) => {
            if (q.typeConfig.id == questionType.id) {
                q.typeConfig = questionType;
            }
        });
    }
}
